import { defineComponent as _defineComponent } from 'vue'
import { useGetReportReasons } from "@/composables/line/useGetReportReasons";
import { IResultData } from "@/domain/entities/shared/result";
import {
  ICustomCode,
  ICustomCodeCollection,
} from "@/domain/entities/system/customCode.types";
import {
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  PROVIDE_KEY_SHOW_TOAST_MESSAGE,
  ShowErrorModal,
  ShowToastMessage,
} from "@/types";
import { computed, inject, onMounted, ref } from "vue";
import ReportReasonButton from "../shared/button/ReportReasonButton.vue";
import BaseButton from "../shared/button/base/BaseButton.vue";
import { useBoardStore } from "@/stores/boardStore";
import Modal from "../shared/modal/base/Modal.vue";


const __default__ = {
  name: "ReportReasonsSelector",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  boardUid: {
    type: String,
    required: true,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;
const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const handleError = (title: string, result: any) => {
  showErrorModal(
    title,
    result.errorMessage,
    result.resultCode,
    result.errorTime
  );
};

const boardStore = useBoardStore();

const selectedReason = ref<ICustomCode>();
const updateSelectedReason = (reason: ICustomCode) => {
  selectedReason.value = reason;
};

const reportGuideContent = computed(() => {
  const reason = selectedReason.value;

  if (!reason?.props?.popupMessage) {
    return "신고하시겠습니까?";
  }

  const formattedHtmlContent = reason.props.popupMessage
    .replace(/\$\{reportName\}/g, reason.name)
    .replace(/&([^&]+)&/g, "<strong>$1</strong>");

  return formattedHtmlContent;
});

const { reportReasons, fetchReportReasons } = useGetReportReasons({
  onError: (result: IResultData<ICustomCodeCollection>) => {
    handleError("신고 사유 조회 오류", result);
  },
});

/** 신고 절차 안내 모달 */
const shouldShowReportGuideModal = ref(false);
const toggleShowReportGuideModal = (show: boolean) => {
  shouldShowReportGuideModal.value = show;
};

const requestReport = async () => {
  if (!props.boardUid) {
    showToastMessage("탑승중인 노선 정보가 올바르지 않습니다.");
    return;
  }

  if (!selectedReason.value) {
    showToastMessage("신고 사유를 선택해주세요");
    return;
  }

  const reportResult = await boardStore.requestReport(
    props.boardUid,
    selectedReason.value
  );

  if (reportResult.isSuccess) {
    showToastMessage("신고가 완료되었습니다");
    selectedReason.value = undefined;
  } else {
    handleError("신고 요청 오류", reportResult);
  }
};

onMounted(() => {
  fetchReportReasons();
});

const __returned__ = { props, showToastMessage, showErrorModal, handleError, boardStore, selectedReason, updateSelectedReason, reportGuideContent, reportReasons, fetchReportReasons, shouldShowReportGuideModal, toggleShowReportGuideModal, requestReport, ReportReasonButton, BaseButton, Modal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})